module.exports = "<div class=\"modal\">\n  <section>\n    <header *ngIf=\"!!title\">\n      <h4 class=\"grow\">{{title}}</h4>\n    </header>\n    <div>\n      <ng-content select=\"[message]\"></ng-content>\n    </div>\n    <footer>\n      <button (click)=\"confirm.next()\">{{confirmLabel}}</button>\n    </footer>\n  </section>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/common/alert-modal/alert-modal.component.html
// module id = 1526
// module chunks = 2